import {
  setDefaults,
  matchfields,
  validationListeners,
  handleSubmit,
  validFields,
} from "../../common/ThreadValidator.js";

export default () => {
  document.querySelectorAll(".js-email-signup__form").forEach((el) => {
    const fieldItem = el.querySelector(".js-form-required");
    const input = el.querySelector("input");
    const link = el.querySelector(".js-email-signup-link");
    const message = el.dataset.message || "";
    const subject = el.dataset.subject || "";

    validationListeners(fieldItem, el);

    input.addEventListener("keyup", (e) => {
      link.href = `mailto:${input.value}?subject=${subject}&body=${message}`;

      if (e.key === "Enter") {
        link.click();
      }
    });

    link.addEventListener("click", (e) => {
      if (!validFields([fieldItem])) {
        e.preventDefault();
        input.focus();
      }
    });
  });
};
